module.exports = __webpack_public_path__ + "img/slack-logo2.cd0c7894.png";